// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3YNWv","inputWrap":"styles_inputWrap__2zZP_","input":"styles_input__2rWFY"};